// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"eaea96e3","336":"cfd7fec9","338":"07ad7ab1","374":"cd186a54","403":"cfcbaf06","551":"e781d435","645":"42e56975"}[chunkId] + ".chunk.js";
};